<template>
  <li class="tag-active-filter mr-3 mb-4" @click="onClickButton">
    <span class="content-text-tag">{{ friendlyName }}</span>
    <i class="material-icons ml-2" v-if="clickable">close</i>
  </li>
</template>

<script>
export default {
  name: "tagactivefilter",
  data: function() {
    return {
      clickable: false,
      friendlyName: ""
    };
  },
  created() {
    switch (this.name) {
      case "tipo":
        this.friendlyName = "Tipo de empreendimento";
        break;
      case "uf":
        this.friendlyName = "Estado";
        this.clickable = true;
        break;
      case "cidade":
        this.friendlyName = "Cidade";
        this.clickable = true;
        break;
      case "fase":
        this.friendlyName = "Fase";
        this.clickable = true;
        break;
      case "qtdDormitorios":
        this.friendlyName = "Dormitórios";
        this.clickable = true;
        break;
      case "qtdSuites":
        this.friendlyName = "Suítes";
        this.clickable = true;
        break;
      case "faixaDePreco":
        this.friendlyName = "Faixa de preço";
        break;
      case "metrosQuadrados":
        this.friendlyName = "Metragem";
        break;
    }
  },
  methods: {
    onClickButton() {
      if (this.clickable) {
        this.$emit("clicked", this.name);
      }
    }
  },
  props: {
    name: { type: String, default: "" }
  }
};
</script>

<style>
/* begin::custom */
.tag-active-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #444444;
  height: 38px;
  padding: 0px 18px;
  border-radius: 50px;
  font-size: 14px;
  color: #444444;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  background: transparent;
  transition: background 0.1s ease;
  white-space: nowrap;
}
.tag-active-filter:hover {
  background: #f6f6f6;
}
/* end::custom */
</style>



// WEBPACK FOOTER //
// src/components/TagActiveFilter.vue